import {PlusOutlined, MinusCircleOutlined} from "@ant-design/icons"
import {NAIRA} from "../../defaults/utilities";
import {formatCurrency} from "../../helpers/currency";
import {useState, useRef, useEffect} from 'react';
import {Form, Input, Button, InputNumber, Space, Select, message, Row, Col} from "antd";
import DataTable from "../common/table";
import {useCreateBudget, useCreateProjection, useUpdateProjection} from "../../hooks/budget/budgetQuery";
import {useFetchAllFinancialYears} from "../../hooks/financialYear/financialYearQuery";
import {extractValueFromInputRef} from "../../helpers/dom";
import {useGetMemoScope} from "../../hooks/memo-scopes/memoScopeQuery";
import {userStore} from "../../store/userStore";
import {useGetAlltBudgetItems} from "../../hooks/budgetItem/budgetItemQuery";
import {useDepartments} from "../../hooks/department/departmentQuery";
import {useGetAllLevels} from "../../hooks/payrollData/payrollDataQuery";
import {useGetAllDesignation} from "../../hooks/designation/designationQuery";
import {useFetchAllStaffCategories, useGetAllStaffCategories} from "../../hooks/staffcategory/staffCategoryQuery";


const {Option} = Select;

let index = 1;


export default function CreateProjectionComponent({toggleOpen, projection, setBudget}) {
    const [item, setItem] = useState({});
    const [initial, setInitial] = useState({});
    const [items, setItems] = useState(projection?.staffProjectionItems?.map(e => ({
        ...e, level: e.level, designation: e.designation, category: e.staffCategory
    })) ?? []);
    const [year, setYear] = useState(projection?.financialYear?.id ?? null);
    const [total, setTotal] = useState(0);
    const [department, setdepartment] = useState(projection?.office?.id ?? null);

    const titleRef = useRef(null);

    const user = userStore(state => state.user);

    const createProjection = useCreateProjection();
    const updateProjection = useUpdateProjection();
    const {years} = useFetchAllFinancialYears();
    const {departments} = useDepartments();
    const {levels} = useGetAllLevels()
    const {designations} = useGetAllDesignation()
    const {categories} = useFetchAllStaffCategories()

    const createBudgetItemColumns = [
        {
            title: 'Category',
            key: 'category',
            dataIndex: 'category',
            render: (_, {category}) => category.title
        },
        {
            title: 'Designation',
            key: 'designation',
            dataIndex: 'designation',
            render: (_, {designation}) => designation.title
        },
        {
            title: 'Level',
            key: 'level',
            dataIndex: 'level',
            render: (_, {level}) => level.title
        },
        {
            title: 'Current',
            key: 'noInPost' ,
            dataIndex: 'noInPost'
        },
        {
           title: 'Proposed',
           key: 'noProposed' ,
           dataIndex: 'noProposed'
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, __, idx) => (
                <div style={{display: 'flex', justifyContent: "flex-end"}}>
                    <Button type="primary" style={{backgroundColor: "red"}} onClick={() => removeItem(idx)}>Remove
                        Item</Button>
                </div>
            )
        }
    ]

    useEffect(() => {
        if(projection){
            console.log("Hey")
            setInitial({
                ...projection,
                items: projection.staffProjectionItems.map(e => ({
                    ...e, level: e.level, designation: e.designation, category: e.staffCategory
                })) ?? [],
                year: projection.financialYear.id,
                department: projection.office?.id ?? null
            })
        }
    }, [projection]);


    function removeItem(id) {
        const item = items.find((_, itemIndex) => itemIndex === id);
        // setTotal(prevTotal => prevTotal -= +(item.amount));
        setItems((prevItems) => (prevItems.filter((_, idx) => idx !== id)))
    }


    function addItem(callback1, callback2) {
        // setItem((prev)=>({...prev,id:index}));
        setItems((prev) => {
            return [...prev, {...item, level: JSON.parse(item.level), designation: JSON.parse(item.designation), category: JSON.parse(item.category)}]
        });
        // setTotal(prevTotal => prevTotal += +(item.amount));
        setItem({});
        callback1()
        callback2();
        index++;
    }


    const handleSubmit = async () => {
        const payload = {
            title: extractValueFromInputRef(titleRef),
            financialYear: year,
            projections: items.map(i => ({
                ...i, staffCategoryId: i.category.id, designationId: i.designation.id,
                levelId: i.level.id
            })),
            userId: user.id,
            departmentId: department
        }
        const {message: response} = await createProjection(payload);
        message.success(response ?? "Projection added successfully")
        toggleOpen();
    }

    const handleUpdate = async () => {
        const payload = {
            title: extractValueFromInputRef(titleRef),
            financialYear: year,
            projections: items.map(i => ({
                ...i, staffCategoryId: i.category.id, designationId: i.designation.id,
                levelId: i.level.id
            })),
            userId: user.id,
            departmentId: department
        }
        const {message: response} = await updateProjection(projection.id, payload);
        message.success(response ?? "Projection updated successfully")
        toggleOpen();
    }


    return (
        <>
            <div style={{
                marginTop: "3em",
                maxWidth: "75vw",
                maxHeight: "70vh",
                overflowY: "scroll",
                paddingLeft: ".5em",
                paddingRight: ".5em"
            }}>
                <Form initialValues = {{
                    ...projection,
                    items: projection?.staffProjectionItems.map(e => ({
                        ...e, level: e.level, designation: e.designation, category: e.staffCategory
                    })) ?? [],
                    year: projection?.financialYear?.id ?? null,
                    department: projection?.office?.id ?? null
                }}>
                    <Form.Item name="title">
                        <Input placeholder="Title" ref={titleRef}/>
                    </Form.Item>
                    <Row gutter={2}>
                        <Col span={12}>
                            <Form.Item name="year">
                                <Select placeholder='Select financial year' onChange={(e) => setYear(e)}>
                                    {
                                        years.map((y, idx) => (
                                            <Option value={y.id} key={idx}>{y.title}</Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                        <Col span={12}>
                            <Form.Item name="department">
                                <Select placeholder="department" onChange={(e) => setdepartment(e)} style={{width: "100%"}}>
                                    {
                                        departments.map((s, idx) => (
                                            <Option key={idx} value={s.id}>{s.title}</Option>
                                        ))
                                    }
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>

                    {
                        items.length > 0 && (
                            <DataTable cols={createBudgetItemColumns} data={items} pagination={false}
                                       rowKey={(item) => item.id} style={{marginBottom: '10px'}}/>
                        )
                    }
                    <Form.List name="eitems" style={{width: '100%'}}>
                        {(fields, {add, remove}) => (
                            <>
                                {fields.map(({key, name, ...restField}) => (
                                    <>
                                        <Space
                                            key={key}
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                marginBottom: 8,
                                                marginTop: 4,
                                                width: '100%',
                                                flexWrap: "wrap",
                                                justifyContent: 'space-between'
                                            }}
                                            align="baseline"
                                        >
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'category']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Missing category',
                                                    },
                                                ]}
                                            >
                                                <Select placeholder='Category' style={{width: '20em'}}
                                                        onChange={(e) => setItem((prevItem) => ({
                                                            ...prevItem,
                                                            category: e
                                                        }))}>
                                                    {
                                                        categories.length > 0 && (
                                                            categories.map((item, idx) => (
                                                                <Option value={JSON.stringify({
                                                                    id: item.id,
                                                                    value: item.value,
                                                                    title: item.title
                                                                })} key={idx}>{item.title}</Option>
                                                            ))
                                                        )
                                                    }
                                                </Select>
                                            </Form.Item>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'level']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Missing Level',
                                                    },
                                                ]}
                                            >
                                                <Select placeholder='Level' style={{width: '20em'}}
                                                        onChange={(e) => setItem((prevItem) => ({
                                                            ...prevItem,
                                                            level: e
                                                        }))}>
                                                    {
                                                        levels.length > 0 && (
                                                            levels.map((item, idx) => (
                                                                <Option value={JSON.stringify({
                                                                    id: item.id,
                                                                    value: item.value,
                                                                    title: item.title
                                                                })} key={idx}>{item.title}</Option>
                                                            ))
                                                        )
                                                    }
                                                </Select>
                                            </Form.Item>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'designations']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Missing designation',
                                                    },
                                                ]}
                                            >
                                                <Select placeholder='Designation' style={{width: '20em'}}
                                                        onChange={(e) => setItem((prevItem) => ({
                                                            ...prevItem,
                                                            designation: e
                                                        }))}>
                                                    {
                                                        designations.length > 0 && (
                                                            designations.map((item, idx) => (
                                                                <Option value={JSON.stringify({
                                                                    id: item.id,
                                                                    value: item.value,
                                                                    title: item.title
                                                                })} key={idx}>{item.title}</Option>
                                                            ))
                                                        )
                                                    }
                                                </Select>
                                            </Form.Item>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'noInPost']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Missing current number',
                                                    },
                                                ]}
                                            >
                                                <InputNumber style={{width: '100%'}}
                                                             onChange={(e) => setItem((prevItem) => ({
                                                                 ...prevItem,
                                                                 noInPost: e
                                                             }))} placeholder="Current number"/>
                                            </Form.Item>
                                            <Form.Item
                                                {...restField}
                                                name={[name, 'noProposed']}
                                                rules={[
                                                    {
                                                        required: true,
                                                        message: 'Missing new proposal',
                                                    },
                                                ]}
                                            >
                                                <InputNumber style={{width: '100%'}}
                                                             onChange={(e) => setItem((prevItem) => ({
                                                                 ...prevItem,
                                                                 noProposed: e
                                                             }))} placeholder="New proposal"/>
                                            </Form.Item>
                                            <div style={{justifyContent: 'flex-end', display: 'flex'}}>
                                                <Form.Item>
                                                    <Button type='primary' style={{backgroundColor: 'lime'}}
                                                            onClick={() => addItem(() => remove(name), add)}>
                                                        Add Item
                                                    </Button>
                                                </Form.Item>
                                                <MinusCircleOutlined onClick={() => remove(name)}
                                                                     style={{marginTop: ".5em", marginLeft: "4px"}}/>
                                            </div>
                                        </Space>
                                    </>
                                ))}
                                {/*<div style={{justifyContent: 'flex-end', display: 'flex'}}>*/}
                                {/*    <span style={{fontWeight: 'bold'}}>Total : {NAIRA} {total}</span>*/}
                                {/*</div>*/}
                                <Form.Item>
                                    <Button type="primary" onClick={() => add()} icon={<PlusOutlined/>}>
                                        {items.length < 1 ? 'Add Budget Item' : 'Add Another Item'}
                                    </Button>
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                    <Form.Item wrapperCol={{

                    }}>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'flex-end'
                        }}>
                            {
                                projection ? <Button type="primary" style={{backgroundColor: 'green'}} onClick={handleUpdate}>
                                    Update
                                </Button> : <Button type="primary" style={{backgroundColor: 'green'}} onClick={handleSubmit}>
                                    Create
                                </Button>
                            }
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </>
    )
};
